import BaseApi from '@/api/base-api'
import request from '@/utils/request'
class MerchantBranchesApi extends BaseApi {
  fetchAllBranches = (params) => {
    return this.request({
      method: 'GET',
      path: this.uri + '/list',
      data: params,
    })
  }
}

const listMerchantBranches = (data) => {
  return request({
    path: `/merchants/branches/list`,
    method: 'POST',
    data,
  })
}

export { listMerchantBranches }
export default new MerchantBranchesApi('/merchants/branches')
